import update from 'immutability-helper';
import { handleActions } from 'redux-actions';
import { get } from 'lodash';

import { localStorage } from 'services';
import { setToken } from 'services/axios';
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  AUTH_ANONYMOUS,
  AUTH_ANONYMOUS_ERROR,
  AUTH_ANONYMOUS_SUCCESS,
  CHECK_LOCAL_AUTH,
  CHECK_LOCAL_AUTH_ERROR,
  CHECK_LOCAL_AUTH_SUCCESS,
  CHECK_LOCAL_AUTH_NOT_CLEAR_DATA_SUCCESS,
  RECOVERY_PASSWORD,
  RECOVERY_PASSWORD_SUCCESS,
  RECOVERY_PASSWORD_ERROR,
  SET_VERIFY_ITEM_CHANGE_PASSWORD,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_ERROR,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS,
  LOGOUT_SUCCESS,
} from '../type';
import { initialState } from './initialize';

const loginReducer = handleActions(
  new Map([
    [
      LOGIN,
      state => {
        return update(state, {
          loginData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      LOGIN_SUCCESS,
      (state, action) => {
        setToken(action.payload.token);
        localStorage.setAuth(action.payload);
        return update(state, {
          loginData: {
            loading: { $set: false },
            data: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      LOGIN_ERROR,
      (state, action) => {
        localStorage.setAuth(null);
        return update(state, {
          loginData: {
            loading: { $set: false },
            error: { $set: action.payload },
          },
        });
      },
    ],
    [
      AUTH_ANONYMOUS,
      state => {
        return update(state, {
          loginData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      AUTH_ANONYMOUS_SUCCESS,
      (state, action) => {
        setToken(action.payload.token);
        localStorage.setAuth(action.payload);
        return update(state, {
          loginData: {
            loading: { $set: false },
            data: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      AUTH_ANONYMOUS_ERROR,
      (state, action) => {
        localStorage.setAuth(null);
        return update(state, {
          loginData: {
            loading: { $set: false },
            error: { $set: action.payload },
          },
        });
      },
    ],
    [
      CHECK_LOCAL_AUTH,
      state => {
        return update(state, {
          loginData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      CHECK_LOCAL_AUTH_ERROR,
      (state, action) => {
        localStorage.setAuth(null);
        return update(state, {
          loginData: {
            loading: { $set: false },
            error: { $set: action.payload },
          },
        });
      },
    ],
    [
      CHECK_LOCAL_AUTH_SUCCESS,
      (state, action) => {
        setToken(action.payload.token);
        localStorage.setAuth(action.payload);
        return update(state, {
          loginData: {
            loading: { $set: false },
            error: { $set: '' },
            data: { $set: action.payload },
          },
          sendVerifyData: {
            error: { $set: '' },
            data: { $set: '' },
            loading: { $set: false },
            verifyItem: { $set: null },
          },
          confirmRecoveryPassword: {
            error: { $set: '' },
            patientIdAfterConfirmChangePassword: { $set: null },
            loading: { $set: false },
          },
          changePassword: {
            error: { $set: '' },
            loading: { $set: false },
          },
          patientLoginInfo: {
            $set: {},
          },
        });
      },
    ],
    [
      CHECK_LOCAL_AUTH_NOT_CLEAR_DATA_SUCCESS,
      (state, action) => {
        setToken(action.payload.token);
        localStorage.setAuth(action.payload);
        return update(state, {
          loginData: {
            loading: { $set: false },
            error: { $set: '' },
            data: {
              email: { $set: null },
              mobile: { $set: null },
              patientId: { $set: null },
              patientName: { $set: null },
            },
          },
          sendVerifyData: {
            error: { $set: '' },
            data: { $set: '' },
            loading: { $set: false },
            verifyItem: { $set: null },
          },
          confirmRecoveryPassword: {
            error: { $set: '' },
            patientIdAfterConfirmChangePassword: { $set: null },
            loading: { $set: false },
          },
          changePassword: {
            error: { $set: '' },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      RECOVERY_PASSWORD,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            error: { $set: '' },
            loading: { $set: true },
          },
          confirmRecoveryPassword: {
            error: { $set: '' },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      RECOVERY_PASSWORD_SUCCESS,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            error: { $set: '' },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      RECOVERY_PASSWORD_ERROR,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            error: { $set: action.payload.message },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      SET_VERIFY_ITEM_CHANGE_PASSWORD,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            verifyItem: { $set: action.payload },
          },
        });
      },
    ],
    [
      CONFIRM_VERIFY_CODE_CHANGE_PASSWORD,
      state => {
        return update(state, {
          loading: {
            confirmVerifyCodeChangePasswordLoading: { $set: true },
          },
          confirmRecoveryPassword: {
            error: { $set: '' },
            loading: { $set: true },
          },
        });
      },
    ],
    [
      CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_ERROR,
      (state, action) => {
        return update(state, {
          loading: {
            confirmVerifyCodeChangePasswordLoading: { $set: false },
          },
          confirmRecoveryPassword: {
            error: { $set: action.payload.message },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_SUCCESS,
      (state, action) => {
        const patientId = get(action.payload, 'patientId');
        return update(state, {
          loading: {
            confirmVerifyCodeChangePasswordLoading: { $set: false },
          },
          confirmRecoveryPassword: {
            error: { $set: '' },
            loading: { $set: false },
            patientIdAfterConfirmChangePassword: { $set: patientId },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD,
      state => {
        return update(state, {
          changePassword: {
            error: { $set: '' },
            loading: { $set: true },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD_ERROR,
      (state, action) => {
        return update(state, {
          changePassword: {
            error: { $set: action.payload.message },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD_SUCCESS,
      (state, action) => {
        return update(state, {
          changePassword: {
            error: { $set: '' },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      LOGOUT_SUCCESS,
      (state, action) => {
        setToken(null);
        localStorage.setAuth(null);
        return update(state, {
          loginData: {
            loading: { $set: false },
            error: { $set: '' },
          },
          patientLoginInfo: {
            $set: {},
          },
        });
      },
    ],
  ]),
  initialState,
);

export default loginReducer;
